import React, {useEffect, useState} from "react";
import styles from "./BusinessList.module.css";

import Business from "../Business/Business";
import ProductLoader from "../ProductList/ProductLoader/ProductLoader";

const BusinessList = ({ businesses, className, loading, searchTerm }) => {
    const [filteredBusinesses, setFilteredBusinesses] = useState([]);

    // Update filtered businesses whenever businesses or searchTerm changes
    useEffect(() => {
        if(!loading){
            if (businesses?.length && searchTerm) {
                const filtered = businesses.filter((business) =>
                                                       business.name.toLowerCase().includes(searchTerm.toLowerCase())
                );
                setFilteredBusinesses(filtered);
            } else {
                setFilteredBusinesses(businesses);
            }
        }
        console.log(searchTerm);
    }, [searchTerm]);

    if(loading) {
        return (
            <ProductLoader
                count={3}
                customClassName={`w-full max-w-full p-0 my-0 mx-auto`}
            />
        )
    }
  return (
      <div className={`${styles.BusinessList} ${className}`}>
          {filteredBusinesses.length > 0 ? (
              filteredBusinesses.map((business) => {
                  return <Business business={business} key={business.id}/>;
              })
          ) : (
               <p className="text-center w-full">No businesses match your search.<br /> Try changing your location.</p>
           )}
      </div>
  );
};

export default BusinessList;
